import { Ticket, Soup, UtensilsCrossed } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { MenuSheet } from "../components/MenuSheet";
import { CtaBanner } from "../sections/CtaBanner";
import { PRICE_NOTE } from "../data/site";

const steps = [
  {
    icon: Ticket,
    title: "Datang & ambil antrean",
    text: "Mampir ke outlet terdekat. Di Melawai, cukup pindai kode QR untuk mengambil nomor antrean digital dan memantau posisimu.",
  },
  {
    icon: Soup,
    title: "Pilih ayam & sambalmu",
    text: "Pilih bagian dada atau paha, lalu tentukan sambalmu: goang yang segar beraroma kencur, bawang yang nendang, atau dua-duanya.",
  },
  {
    icon: UtensilsCrossed,
    title: "Santap selagi panas",
    text: "Ayam digoreng sebentar begitu dipesan, lalu disajikan panas dengan nasi pulen, jukut goreng, dan lalapan.",
  },
];

export default function MenuPage() {
  return (
    <div data-testid="menu-page">
      <PageHero
        eyebrow="Menu & Harga"
        title="Selembar menu yang bikin antre."
        description="Fokus kami satu: ayam goreng basah khas Bandung dengan bumbu ungkep kuning, jukut goreng, dan dua sambal khas — plus pelengkap yang sayang dilewatkan."
        crumbs={[
          { label: "Beranda", href: "/" },
          { label: "Menu", href: "/menu/" },
        ]}
      />

      <section className="mx-auto max-w-6xl px-5 py-14 sm:py-20" aria-label="Daftar menu">
        <div className="grid items-start gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <MenuSheet />
            <p className="mt-6 text-xs leading-relaxed text-charcoal-muted">
              {PRICE_NOTE}
            </p>
          </div>

          <aside className="lg:col-span-5">
            <h2 className="font-heading text-2xl font-extrabold tracking-tight text-charcoal">
              Cara menikmatinya
            </h2>
            <ol className="mt-8 space-y-8">
              {steps.map((s, i) => (
                <li key={s.title} className="flex gap-5">
                  <span className="flex h-12 w-12 shrink-0 flex-col items-center justify-center rounded-lg border-2 border-dashed border-bumbu bg-bumbu-light font-mono text-sm font-bold text-bumbu-deep">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="flex items-center gap-2 font-heading text-base font-bold text-charcoal">
                      <s.icon className="h-4 w-4 text-bumbu" aria-hidden="true" />
                      {s.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-charcoal-muted">
                      {s.text}
                    </p>
                  </div>
                </li>
              ))}
            </ol>

            <figure className="mt-10 overflow-hidden rounded-lg border border-amber-900/15">
              <img
                src="/images/plate.webp"
                alt="Seporsi nasi dengan ayam goreng dan sambal pendamping"
                width="1200"
                height="800"
                loading="lazy"
                className="aspect-[3/2] w-full object-cover"
              />
            </figure>
          </aside>
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
